// Final CTA section — closing immersive moment after pricing.
//
// Same glassy section treatment as demo + pricing (gradient envelope
// black → #0E1012 → black, single soft top-edge light catch, Meta Blue
// radial halo for decorative depth). Centered headline + subhead + a
// single Meta Blue pill CTA. Display 2 headline, Body subhead, Title
// Case button per CLAUDE.md feedback_button_title_case.
import { emit } from '../lib/analytics';
import { buildHandoffUrl } from '../lib/handoff';
import { CHANNEL_COPY, type Channel } from '../lib/channel-copy';

export function FinalCta({ channel = 'both' }: { channel?: Channel }) {
  const ctaHref = buildHandoffUrl('');
  return (
    <section
      data-testid="final-cta"
      className="relative overflow-hidden bg-gradient-to-b from-black via-[#0E1012] to-black px-6 py-16 md:py-24"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/12 to-transparent"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#0064E0]/12 blur-[180px]"
      />
      <div className="relative mx-auto max-w-3xl text-center">
        <h2
          className="text-4xl md:text-5xl font-medium tracking-tight leading-[1.17] text-white"
          style={{ letterSpacing: '-0.015em' }}
        >
          {CHANNEL_COPY[channel].finalCtaHeadline}
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-[1.44] text-white/65">
          Skip weeks of bureaucracy, approvals, BS, and setup hell.
        </p>
        <div className="mt-10 flex justify-center">
          <a
            href={ctaHref}
            onClick={() =>
              emit('cta_clicked', {
                cta_location: 'final_cta',
                cta_text: 'Start Free',
                destination_url: ctaHref,
              })
            }
            className="inline-flex items-center justify-center rounded-[100px] bg-[#0064E0] hover:bg-[#0143B5] active:bg-[#004BB9] px-8 py-4 text-base font-medium text-white transition shadow-[0_8px_24px_rgba(0,100,224,0.35)]"
          >
            Start Free
          </a>
        </div>
      </div>
    </section>
  );
}
